module.exports = __webpack_public_path__ + "img/swiper5.c2fe4761.png";